// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SOLUZIONE 1 CUSTOM CSS */
.flagIcon {
  width: 20px;
  margin: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/routes/pages/login/login.component.scss"],"names":[],"mappings":"AAAA,2BAAA;AACA;EAAY,WAAA;EAAY,YAAA;AAGxB","sourcesContent":["/* SOLUZIONE 1 CUSTOM CSS */\n.flagIcon { width:20px; margin:15px; }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
